// import { BsMenuButtonWideFill } from "react-icons/bs";
// const AdminHome = () => {
//     return(
//         <>
   

//                     <div className="col-lg-3">
//                         <div className="wrap-sidebar-account">
//                             <ul className="my-account-nav">
//                                 {/* <li><span className="my-account-nav-item active">Home</span></li> */}
//                                 <li><a href="/dashboard" className="my-account-nav-item">Dashboard</a></li>

//                                 <li><a href="/adminaddproduct" className="my-account-nav-item">Add Products</a></li>
//                                 <li><a href="/adminorders" className="my-account-nav-item">Orders</a></li>
//                                 <li><a href="/admincategory" className="my-account-nav-item">Add Category</a></li>
//                                 <li><a href="/Category" className="my-account-nav-item">Categories</a></li>
//                                 <li><a href="/adminstyle" className="my-account-nav-item">Add Style Type</a></li>
//                                 <li><a href="/adminrentform" className="my-account-nav-item">Add SubModules</a></li>
//                                 <li><a href="/Styles" className="my-account-nav-item">Edit Submodules</a></li>
//                                 {/* <li><a href="/adminorders" className="my-account-nav-item">Orders</a></li> */}
//                                 <li><a href="/ProductManagement" className="my-account-nav-item">Product Management</a></li>
//                                 <li><a href="/adminallproducts" className="my-account-nav-item">Stock Management</a></li>
//                                 {/* <li><a href="/wishlist" className="my-account-nav-item">Wishlist</a></li> */}

//                             </ul>
//                         </div>
//                     </div>
                    

//         <div className="btn-sidebar-account">
//             <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas"><BsMenuButtonWideFill /></button>
//         </div>
        
        
//         </>
//     )
// }
// export default AdminHome

// import React, { useState } from 'react';
// import { BsMenuButtonWideFill, BsChevronDown, BsChevronUp } from 'react-icons/bs';
// import { 
//   TbDashboard, 
//   TbPackage, 
//   TbClipboardList, 
//   TbTruck, 
//   TbSettings 
// } from 'react-icons/tb';

// const AdminHome = () => {
//     const [openDropdown, setOpenDropdown] = useState(null);
//     const [isHovered, setIsHovered] = useState(null);

//     const toggleDropdown = (name) => {
//         setOpenDropdown(openDropdown === name ? null : name);
//     };

//     const navigationItems = [
//         {
//             label: 'Dashboard',
//             type: 'link',
//             href: '/dashboard',
//             icon: <TbDashboard className="w-5 h-5" />
//         },
//         {
//             label: 'Product Management',
//             type: 'dropdown',
//             icon: <TbPackage className="w-5 h-5" />,
//             items: [
//                 { label: 'Add Products', href: '/adminaddproduct' },
//                 { label: 'Product Management', href: '/ProductManagement' }
//             ]
//         },
//         {
//             label: 'Inventory',
//             type: 'dropdown',
//             icon: <TbClipboardList className="w-5 h-5" />,
//             items: [
//                 { label: 'Stock Management', href: '/adminallproducts' }
//             ]
//         },
//         {
//             label: 'Order Management',
//             type: 'link',
//             href: '/adminorders',
//             icon: <TbTruck className="w-5 h-5" />
//         },
//         {
//             label: 'Lookup',
//             type: 'dropdown',
//             icon: <TbSettings className="w-5 h-5" />,
//             items: [
//                 { label: 'Add Category', href: '/admincategory' },
//                 { label: 'Categories', href: '/Category' },
//                 { label: 'Add Style Type', href: '/adminstyle' },
//                 { label: 'Add SubModules', href: '/adminrentform' },
//                 { label: 'Edit Submodules', href: '/Styles' }
//             ]
//         }
//     ];

//     return (
//         <>
//             <div className="col-lg-3">
//                 <div className="bg-white shadow-lg rounded-lg p-4">
//                     <div className="mb-6">
//                         <h2 className="text-xl font-bold text-gray-800 px-4">Admin Panel</h2>
//                     </div>
//                     <ul className="space-y-2">
//                         {navigationItems.map((item, index) => (
//                             <li 
//                                 key={index}
//                                 onMouseEnter={() => setIsHovered(item.label)}
//                                 onMouseLeave={() => setIsHovered(null)}
//                             >
//                                 {item.type === 'link' ? (
//                                     <a 
//                                         href={item.href} 
//                                         className={`
//                                             flex items-center px-4 py-3 rounded-lg transition-all duration-200
//                                             ${isHovered === item.label ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-blue-50 hover:text-blue-600'}
//                                         `}
//                                     >
//                                         <span className="mr-3">{item.icon}</span>
//                                         {item.label}
//                                     </a>
//                                 ) : (
//                                     <div className="relative">
//                                         <button
//                                             onClick={() => toggleDropdown(item.label)}
//                                             className={`
//                                                 w-full flex items-center justify-between px-4 py-3 rounded-lg transition-all duration-200
//                                                 ${openDropdown === item.label ? 'bg-blue-50 text-blue-600' : 'text-gray-600 hover:bg-blue-50 hover:text-blue-600'}
//                                             `}
//                                         >
//                                             <span className="flex items-center">
//                                                 <span className="mr-3">{item.icon}</span>
//                                                 {item.label}
//                                             </span>
//                                             {openDropdown === item.label ? (
//                                                 <BsChevronUp className="w-4 h-4" />
//                                             ) : (
//                                                 <BsChevronDown className="w-4 h-4" />
//                                             )}
//                                         </button>
//                                         {openDropdown === item.label && (
//                                             <ul className="mt-2 ml-12 space-y-2">
//                                                 {item.items.map((subItem, subIndex) => (
//                                                     <li key={subIndex}>
//                                                         <a
//                                                             href={subItem.href}
//                                                             className="block px-4 py-2 text-sm text-gray-600 rounded-md hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200"
//                                                         >
//                                                             {subItem.label}
//                                                         </a>
//                                                     </li>
//                                                 ))}
//                                             </ul>
//                                         )}
//                                     </div>
//                                 )}
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>

//             <div className="btn-sidebar-account lg:hidden">
//                 <button 
//                     className="p-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-200"
//                     data-bs-toggle="offcanvas" 
//                     data-bs-target="#mbAccount" 
//                     aria-controls="offcanvas"
//                 >
//                     <BsMenuButtonWideFill className="w-6 h-6" />
//                 </button>
//             </div>
//         </>
//     );
// };

// export default AdminHome;

// import React, { useState } from "react";
// import { BsMenuButtonWideFill, BsChevronDown, BsChevronUp } from "react-icons/bs";

// const AdminHome = () => {
//   const [openDropdown, setOpenDropdown] = useState("");

//   const handleDropdown = (dropdown) => {
//     setOpenDropdown(openDropdown === dropdown ? "" : dropdown);
//   };

//   return (
//     <>
//       <div className="col-lg-3">
//         <div className="wrap-sidebar-account">
//           <ul className="my-account-nav">
//             <li>
//               <a href="/dashboard" className="my-account-nav-item">
//                 Dashboard
//               </a>
//             </li>

//             {/* Product Management Dropdown */}
//             <li>
//               <div
//                 className="my-account-nav-item"
//                 onClick={() => handleDropdown("products")}
//                 style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//               >
//                 <span>Product Management</span>
//                 {openDropdown === "products" ? (
//                   <BsChevronUp style={{ marginLeft: "10px" }} />
//                 ) : (
//                   <BsChevronDown style={{ marginLeft: "10px" }} />
//                 )}
//               </div>
//               {openDropdown === "products" && (
//                 <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//                   <li>
//                     <a href="/adminaddproduct" className="my-account-nav-item">
//                       Add Products
//                     </a>
//                   </li>
//                   <li>
//                     <a href="/ProductManagement" className="my-account-nav-item">
//                       Product Management
//                     </a>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             {/* Inventory Dropdown */}
//             <li>
//               <div
//                 className="my-account-nav-item"
//                 onClick={() => handleDropdown("inventory")}
//                 style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//               >
//                 <span>Inventory</span>
//                 {openDropdown === "inventory" ? (
//                   <BsChevronUp style={{ marginLeft: "10px" }} />
//                 ) : (
//                   <BsChevronDown style={{ marginLeft: "10px" }} />
//                 )}
//               </div>
//               {openDropdown === "inventory" && (
//                 <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//                   <li>
//                     <a href="/adminallproducts" className="my-account-nav-item">
//                       Stock Management
//                     </a>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             {/* Orders Dropdown */}
//             <li>
//               <div
//                 className="my-account-nav-item"
//                 onClick={() => handleDropdown("orders")}
//                 style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//               >
//                 <span>Order Management</span>
//                 {openDropdown === "orders" ? (
//                   <BsChevronUp style={{ marginLeft: "10px" }} />
//                 ) : (
//                   <BsChevronDown style={{ marginLeft: "10px" }} />
//                 )}
//               </div>
//               {openDropdown === "orders" && (
//                 <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//                   <li>
//                     <a href="/adminorders" className="my-account-nav-item">
//                       Orders
//                     </a>
//                   </li>
//                 </ul>
//               )}
//             </li>

//             {/* Lookup Dropdown */}
//             <li>
//               <div
//                 className="my-account-nav-item"
//                 onClick={() => handleDropdown("lookup")}
//                 style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//               >
//                 <span>Lookup</span>
//                 {openDropdown === "lookup" ? (
//                   <BsChevronUp style={{ marginLeft: "10px" }} />
//                 ) : (
//                   <BsChevronDown style={{ marginLeft: "10px" }} />
//                 )}
//               </div>
//               {openDropdown === "lookup" && (
//                 <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//                   <li>
//                     <a href="/admincategory" className="my-account-nav-item">
//                       Add Category
//                     </a>
//                   </li>
//                   <li>
//                     <a href="/Category" className="my-account-nav-item">
//                       Categories
//                     </a>
//                   </li>
//                   <li>
//                     <a href="/adminstyle" className="my-account-nav-item">
//                       Add Style Type
//                     </a>
//                   </li>
//                   <li>
//                     <a href="/adminrentform" className="my-account-nav-item">
//                       Add SubModules
//                     </a>
//                   </li>
//                   <li>
//                     <a href="/Styles" className="my-account-nav-item">
//                       Edit Submodules
//                     </a>
//                   </li>
//                 </ul>
//               )}
//             </li>
//           </ul>
//         </div>
//       </div>

//       <div className="btn-sidebar-account">
//         <button
//           data-bs-toggle="offcanvas"
//           data-bs-target="#mbAccount"
//           aria-controls="offcanvas"
//         >
//           <BsMenuButtonWideFill />
//         </button>
//       </div>

//       <style jsx>{`
//         .wrap-sidebar-account {
//           padding: 15px;
//           background-color: #f8f9fa;
//           border-radius: 8px;
//         }

//         .my-account-nav {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }

//         .my-account-nav > li {
//           margin-bottom: 10px;
//         }

//         .my-account-nav-item {
//           display: block;
//           padding: 8px 15px;
//           color: #555;
//           text-decoration: none;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           background-color: #fff;
//           transition: all 0.3s ease;
//         }

//         .my-account-nav-item:hover {
//           background-color: #f0f0f0;
//           color: #333;
//         }

//         .sub-menu {
//           list-style: none;
//           margin: 0;
//           padding: 0;
//         }

//         .sub-menu .my-account-nav-item {
//           margin-top: 5px;
//           background-color: #f9f9f9;
//         }

//         .btn-sidebar-account button {
//           background-color: #007bff;
//           color: #fff;
//           border: none;
//           padding: 10px 15px;
//           border-radius: 4px;
//         }
//       `}</style>
//     </>
//   );
// };

// export default AdminHome;


// karthik comment original code here //
// import React, { useState, useEffect } from "react";
// import { BsMenuButtonWideFill, BsChevronDown, BsChevronUp } from "react-icons/bs";



// const AdminHome = () => {
//   const [openDropdown, setOpenDropdown] = useState("");
//   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isMobileMenuOpen && !event.target.closest('.mobile-menu') && !event.target.closest('.btn-sidebar-account')) {
//         setIsMobileMenuOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [isMobileMenuOpen]);

//   const handleDropdown = (dropdown) => {
//     setOpenDropdown(openDropdown === dropdown ? "" : dropdown);
//   };

//   const NavContent = () => (
//     <ul className="my-account-nav">
//       <li>
//         <a href="/dashboard" className="my-account-nav-item">
//           Dashboard
//         </a>
//       </li>
//       <li>
//         <a href="/salesreport" className="my-account-nav-item">
//          Sales Report
//         </a>
//       </li>

//       {/* Product Management Dropdown */}
//       <li>
//         <div
//           className="my-account-nav-item"
//           onClick={() => handleDropdown("products")}
//           style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//         >
//           <span>Product Management</span>
//           {openDropdown === "products" ? (
//             <BsChevronUp style={{ marginLeft: "10px" }} />
//           ) : (
//             <BsChevronDown style={{ marginLeft: "10px" }} />
//           )}
//         </div>
//         {openDropdown === "products" && (
//           <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//             <li>
//               <a href="/adminaddproduct" className="my-account-nav-item">
//                 Add Products
//               </a>
//             </li>
//             <li>
//               <a href="/ProductManagement" className="my-account-nav-item">
//                 Product Management
//               </a>
//             </li>
//           </ul>
//         )}
//       </li>

//       {/* Inventory Dropdown */}
//       <li>
//         <div
//           className="my-account-nav-item"
//           onClick={() => handleDropdown("inventory")}
//           style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//         >
//           <span>Inventory</span>
//           {openDropdown === "inventory" ? (
//             <BsChevronUp style={{ marginLeft: "10px" }} />
//           ) : (
//             <BsChevronDown style={{ marginLeft: "10px" }} />
//           )}
//         </div>
//         {openDropdown === "inventory" && (
//           <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//             <li>
//               <a href="/adminallproducts" className="my-account-nav-item">
//                 Stock Management
//               </a>
//             </li>
//           </ul>
//         )}
//       </li>

//       {/* Orders Dropdown */}
//       <li>
//         <div
//           className="my-account-nav-item"
//           onClick={() => handleDropdown("orders")}
//           style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//         >
//           <span>Order Management</span>
//           {openDropdown === "orders" ? (
//             <BsChevronUp style={{ marginLeft: "10px" }} />
//           ) : (
//             <BsChevronDown style={{ marginLeft: "10px" }} />
//           )}
//         </div>
//         {openDropdown === "orders" && (
//           <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//             <li>
//               <a href="/adminorders" className="my-account-nav-item">
//                 Orders
//               </a>
//             </li>
//           </ul>
//         )}
//       </li>

//       {/* Lookup Dropdown */}
//       <li>
//         <div
//           className="my-account-nav-item"
//           onClick={() => handleDropdown("lookup")}
//           style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
//         >
//           <span>Lookup</span>
//           {openDropdown === "lookup" ? (
//             <BsChevronUp style={{ marginLeft: "10px" }} />
//           ) : (
//             <BsChevronDown style={{ marginLeft: "10px" }} />
//           )}
//         </div>
//         {openDropdown === "lookup" && (
//           <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
//             <li>
//               <a href="/admincategory" className="my-account-nav-item">
//                 Add Category
//               </a>
//             </li>
//             <li>
//               <a href="/Category" className="my-account-nav-item">
//                 Categories
//               </a>
//             </li>
//             <li>
//               <a href="/adminstyle" className="my-account-nav-item">
//                 Add Style Type
//               </a>
//             </li>
//             <li>
//               <a href="/adminrentform" className="my-account-nav-item">
//                 Add SubModules
//               </a>
//             </li>
//             <li>
//               <a href="/Styles" className="my-account-nav-item">
//                 Edit Submodules
//               </a>
//             </li>
//           </ul>
//         )}
//       </li>
//     </ul>
//   );

//   return (
//     <>
//       {/* Desktop Sidebar */}
//       <div className="col-lg-3">
//         <div className="wrap-sidebar-account">
//           <NavContent />
//         </div>
//       </div>

//       {/* Mobile Menu Button */}
//       {/* <div className="mobile-menu-button">
//         <button
//           className="btn-sidebar-account"
//           onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
//         >
//           <BsMenuButtonWideFill />
//         </button>
//       </div> */}

//       {/* Mobile Menu */}
//       {isMobileMenuOpen && (
//         <div className="mobile-menu">
//           <div className="mobile-menu-content">
//             <NavContent />
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         .wrap-sidebar-account {
//           padding: 15px;
//           background-color: #f8f9fa;
//           border-radius: 8px;
//         }

//         .my-account-nav {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//         }

//         .my-account-nav > li {
//           margin-bottom: 10px;
//         }

//         .my-account-nav-item {
//           display: block;
//           padding: 8px 15px;
//           color: #555;
//           text-decoration: none;
//           border: 1px solid #ddd;
//           border-radius: 4px;
//           background-color: #fff;
//           transition: all 0.3s ease;
//         }

//         .my-account-nav-item:hover {
//           background-color: #f0f0f0;
//           color: #333;
//         }

//         .sub-menu {
//           list-style: none;
//           // margin: 0;
//           // padding: 0;
//         }

//         .sub-menu .my-account-nav-item {
//           margin-top: 5px;
//           background-color: #f9f9f9;
//         }

//         .mobile-menu-button {
//           display: none;
//         }

//         .btn-sidebar-account {
//           border: none;
//           padding: 10px 15px;
//           border-radius: 4px;
//           cursor: pointer;
//         }

//         @media (max-width: 768px) {
//           .col-lg-3 {
//             display: none;
//           }

//           .mobile-menu-button {
//             display: block;
//             position: fixed;
//             bottom: 20px;
//             right: 20px;
//             z-index: 1000;
//           }

//           .mobile-menu {
//             position: fixed;
//             top: 0;
//             left: 0;
//             width: 100%;
//             height: 100%;
//             background-color: rgba(0, 0, 0, 0.5);
//             z-index: 999;
//           }

//           .mobile-menu-content {
//             position: fixed;
//             top: 0;
//             left: 0;
//             width: 80%;
//             max-width: 300px;
//             height: 100%;
//             background-color: #fff;
//             overflow-y: auto;
//             padding: 20px;
//             box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
//             animation: slideIn 0.3s ease-out;
//           }

//           @keyframes slideIn {
//             from {
//               transform: translateX(-100%);
//             }
//             to {
//               transform: translateX(0);
//             }
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default AdminHome;

// karthik end original  code here //




import React, { useState, useEffect } from "react";
import { BsMenuButtonWideFill, BsChevronDown, BsChevronUp } from "react-icons/bs";

const AdminHome = () => {
  const [openDropdown, setOpenDropdown] = useState("");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isMobileMenuOpen &&
        !event.target.closest(".mobile-menu") &&
        !event.target.closest(".btn-sidebar-account")
      ) {
        setIsMobileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMobileMenuOpen]);

  const handleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? "" : dropdown);
  };

  const NavContent = () => (
    <ul className="my-account-nav">
      <li>
        <a href="/dashboard" className="my-account-nav-item">Dashboard</a>
      </li>
      <li>
        <a href="/salesreport" className="my-account-nav-item">Sales Report</a>
      </li>

      {/* Product Management Dropdown */}
      <li>
        <div
          className="my-account-nav-item"
          onClick={() => handleDropdown("products")}
          style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
        >
          <span>Product Management</span>
          {openDropdown === "products" ? <BsChevronUp /> : <BsChevronDown />}
        </div>
        {openDropdown === "products" && (
          <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
            <li>
              <a href="/adminaddproduct" className="my-account-nav-item">Add Products</a>
            </li>
            <li>
              <a href="/ProductManagement" className="my-account-nav-item">Product Management</a>
            </li>
          </ul>
        )}
      </li>

      {/* Inventory Dropdown */}
      <li>
        <div
          className="my-account-nav-item"
          onClick={() => handleDropdown("inventory")}
          style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
        >
          <span>Inventory</span>
          {openDropdown === "inventory" ? <BsChevronUp /> : <BsChevronDown />}
        </div>
        {openDropdown === "inventory" && (
          <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
            <li>
              <a href="/adminallproducts" className="my-account-nav-item">Stock Management</a>
            </li>
          </ul>
        )}
      </li>

      {/* Orders Dropdown */}
      <li>
        <div
          className="my-account-nav-item"
          onClick={() => handleDropdown("orders")}
          style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
        >
          <span>Order Management</span>
          {openDropdown === "orders" ? <BsChevronUp /> : <BsChevronDown />}
        </div>
        {openDropdown === "orders" && (
          <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
            <li>
              <a href="/adminorders" className="my-account-nav-item">Orders</a>
            </li>
          </ul>
        )}
      </li>

      {/* Lookup Dropdown */}
      <li>
        <div
          className="my-account-nav-item"
          onClick={() => handleDropdown("lookup")}
          style={{ cursor: "pointer", display: "flex", justifyContent: "space-between" }}
        >
          <span>Lookup</span>
          {openDropdown === "lookup" ? <BsChevronUp /> : <BsChevronDown />}
        </div>
        {openDropdown === "lookup" && (
          <ul className="sub-menu" style={{ paddingLeft: "20px", marginTop: "5px" }}>
            <li><a href="/admincategory" className="my-account-nav-item">Add Category</a></li>
            <li><a href="/Category" className="my-account-nav-item">Categories</a></li>
            <li><a href="/adminstyle" className="my-account-nav-item">Add Style Type</a></li>
            <li><a href="/adminrentform" className="my-account-nav-item">Add SubModules</a></li>
            <li><a href="/Styles" className="my-account-nav-item">Edit Submodules</a></li>
          </ul>
        )}
      </li>
    </ul>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="col-lg-3">
        <div className="wrap-sidebar-account">
          <NavContent />
        </div>
      </div>

      {/* ✅ Mobile Menu Button - Un-commented */}
      <div className="mobile-menu-button">
        <button
          className="btn-sidebar-account"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        >
          <BsMenuButtonWideFill />
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="mobile-menu">
          <div className="mobile-menu-content">
            <NavContent />
          </div>
        </div>
      )}

      <style jsx>{`
        .wrap-sidebar-account {
          padding: 15px;
          background-color: #f8f9fa;
          border-radius: 8px;
        }

        .my-account-nav {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .my-account-nav > li {
          margin-bottom: 10px;
        }

        .my-account-nav-item {
          display: block;
          padding: 8px 15px;
          color: #555;
          text-decoration: none;
          border: 1px solid #ddd;
          border-radius: 4px;
          background-color: #fff;
          transition: all 0.3s ease;
        }

        .my-account-nav-item:hover {
          background-color: #f0f0f0;
          color: #333;
        }

        .sub-menu .my-account-nav-item {
          margin-top: 5px;
          background-color: #f9f9f9;
        }

        .mobile-menu-button {
          display: none;
        }

        .btn-sidebar-account {
          border: none;
          padding: 10px 15px;
          border-radius: 4px;
          cursor: pointer;
        }

        @media (max-width: 768px) {
          .col-lg-3 {
            display: none;
          }

          .mobile-menu-button {
            display: block;
            position: fixed;
            bottom: 20px;
            right: 20px;
            z-index: 1000;
            background-color: #fff;
            border: 1px solid #ddd;
            border-radius: 50%;
            padding: 10px;
          }

          .mobile-menu {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 999;
          }

          .mobile-menu-content {
            position: fixed;
            top: 0;
            left: 0;
            width: 80%;
            max-width: 300px;
            height: 100%;
            background-color: #fff;
            overflow-y: auto;
            padding: 20px;
            box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
            animation: slideIn 0.3s ease-out;
          }

          @keyframes slideIn {
            from {
              transform: translateX(-100%);
            }
            to {
              transform: translateX(0);
            }
          }
        }
      `}</style>
    </>
  );
};

export default AdminHome;
